// extracted by mini-css-extract-plugin
module.exports = {"table":"InnerTable_table__2h8zq"};